import { isValid } from "date-fns";
import z from "zod";

export const editRentalInfoSchema = () =>
  z
    .object({
      availableFrom: z.coerce.date().optional(),
      rentalPrice: z.coerce.number().int().positive().optional(),
      showingFrom: z.coerce.date().optional(),
    })
    .refine(
      (data) => {
        if (data.availableFrom && data.showingFrom) {
          return data.availableFrom >= data.showingFrom;
        }
        return true;
      },
      {
        message: "Rental start date is before showing start date",
        path: ["availableFrom"],
      }
    );

export const formattedDate = (date: string) => {
  if (date === null || date === undefined || isValid(date)) return "---";
  else {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }
};
